import invitationsActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

const sendGroupInvitationFailure = (newState: any, action: any) => {
  return {
    ...newState,
    response: action.response,
  };
};

export const reducers = {
  userInvitations: createAsyncRequestReducer(
    invitationsActionTypes.GET_USER_INVITATIONS,
  ),
  sendGroupInvitation: createAsyncRequestReducer(
    invitationsActionTypes.SEND_GROUP_INVITATION,
    {
      asyncReducers: {
        failure: sendGroupInvitationFailure,
      },
    },
  ),
  respondToInvitation: createAsyncRequestReducer(
    invitationsActionTypes.RESPOND_TO_INVITATION,
  ),
  sendOpenLinkInvitation: createAsyncRequestReducer(
    invitationsActionTypes.SEND_OPEN_LINK_INVITATION,
  ),
};

export default combineReducers(reducers);
